import config from "@/config"
import http from "@/utils/request"

export default {
	list:{
       index:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/index`,
            name: "获取订单列表",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
        getBadge:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/getBadge`,
            name: "编辑",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        add:{
            url: `${config.API_URL}/bwmall/admin/question/add`,
            name: "添加",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        del:{
            url: `${config.API_URL}/bwmall/admin/question/del`,
            name: "删除",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        modify:{
            url: `${config.API_URL}/bwmall/admin/question/modify`,
            name: "变更",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        //订单详情（GET ?id=）
        orderInfo:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/orderInfo`,
            name: "订单详情",
            get: async function(data={}){
                return await http.get(this.url, data);
            }
        },
        //发货（POST：id/type=1/delivery_name快递公司/delivery_id运单号）
        orderSend:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/orderSend`,
            name: "订单发货",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //修改物流（POST：id/delivery_name快递公司/delivery_id运单号，发货后修改配送信息）
        postInfo:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/postInfo`,
            name: "修改物流",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //查看物流（GET ?id=订单ID，返回快递公司与轨迹时间线）
        express:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/express`,
            name: "查看物流",
            get: async function(data={}){
                return await http.get(this.url, data);
            }
        },
        //同意退款（POST：id/refund_price/type=1/refund_type=2）
        refundY:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/refundY`,
            name: "同意退款",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //拒绝退款（POST：id/refund_reason）
        refundN:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/refundN`,
            name: "拒绝退款",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //订单备注（POST：id/remark）
        remark:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/remark`,
            name: "订单备注",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //订单记录（GET ?id=，返回订单状态流转日志）
        orderLog:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/orderLog`,
            name: "订单记录",
            get: async function(data={}){
                return await http.get(this.url, data);
            }
        },
        //订单核销（POST：verify_code 核销码，仅到店自提待核销单）
        verify:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/verify`,
            name: "订单核销",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        },
        //退积分（POST：id + back_integral 本次退回数；累计不超 use_integral）
        integralBack:{
            url: `${config.API_URL}/bwmall/admin/bwmallShopOrder/integralBack`,
            name: "退积分",
            post: async function(data={}){
                return await http.post(this.url, data);
            }
        }
    },
    express:{
        index:{
            url: `${config.API_URL}/bwmall/admin/express/index`,
            name: "物流快递列表",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
        modify:{
            url: `${config.API_URL}/bwmall/admin/express/modify`,
            name: "变更物流快递列表",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        edit:{
            url: `${config.API_URL}/bwmall/admin/express/edit`,
            name: "编辑物流快递列表",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        add:{
            url: `${config.API_URL}/bwmall/admin/express/add`,
            name: "添加物流快递列表",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        del:{
            url: `${config.API_URL}/bwmall/admin/express/del`,
            name: "删除物流快递列表",
            post: async function(params){
                return await http.post(this.url, params);
            }
        }
    }

}
